var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVanHanh = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5714C0 12.7919 12.7919 0 28.5714 0H71.4286C87.2081 0 100 12.7919 100 28.5714V71.4286C100 87.2081 87.2081 100 71.4286 100H28.5714C12.7919 100 0 87.2081 0 71.4286V28.5714Z",
    fill: "url(#paint0_linear_449_804)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_449_804)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_449_804",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 66,
    height: 66
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8572 17.8571H82.1429V82.1428H17.8572V17.8571Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_449_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.676 25.2682C37.5562 21.8642 43.612 19.7405 50 19.7405C66.6156 19.7405 80.2595 33.3844 80.2595 50C80.2595 57.1201 77.6517 63.6712 73.5071 68.8337",
    stroke: "white",
    strokeWidth: 3.76674,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6006 59.4169V68.8337H82.143",
    stroke: "white",
    strokeWidth: 3.76674,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1984 74.7318C62.3182 78.1358 56.388 80.2595 50 80.2595C33.3844 80.2595 19.7405 66.6156 19.7405 50C19.7405 42.88 22.2228 36.3289 26.3673 31.1663",
    stroke: "white",
    strokeWidth: 3.76674,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.274 40.5833V31.1664H17.8572",
    stroke: "white",
    strokeWidth: 3.76674,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5336 50C57.5336 54.1606 54.1607 57.5334 50.0001 57.5334C45.8395 57.5334 42.3411 54.1606 42.3411 50C42.3411 45.8393 45.8395 42.4665 50.0001 42.4665C54.1607 42.4665 57.5336 45.8393 57.5336 50Z",
    stroke: "white",
    strokeWidth: 3.76674,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8337 53.7668V46.2333H64.5344C64.1797 44.8637 63.6374 43.5803 62.9363 42.3908L65.9808 39.3461L60.654 34.019L57.6092 37.0638C56.4201 36.3627 55.1362 35.8205 53.7668 35.4658V31.1663H46.2333V35.4658C44.8638 35.8205 43.4544 36.3627 42.2653 37.0638L39.2205 34.019L33.8937 39.3461L36.9384 42.3908C36.2371 43.5803 35.695 44.8637 35.3401 46.2333H31.0408V53.7668H35.3401C35.695 55.1366 36.2371 56.4198 36.9384 57.6092L33.8937 60.654L39.2205 65.9808L42.2653 62.936C43.4547 63.6373 44.8638 64.1796 46.2333 64.5343V68.8337H53.7668V64.5343C55.1362 64.1796 56.4199 63.6373 57.6092 62.936L60.654 65.9808L65.9808 60.654L62.9363 57.6092C63.6374 56.4198 64.1797 55.1366 64.5344 53.7668H68.8337Z",
    stroke: "white",
    strokeWidth: 3.76674,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_804",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B584FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8D61CE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.2857,
    height: 64.2857,
    fill: "white",
    transform: "translate(17.8572 17.8572)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVanHanh, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/VanHanh.3ac81730.svg";
export { ForwardRef as ReactComponent };